import Typography from '@lib/components/Typography/Typography';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { AiAssistantTexts } from './getAiAssistantTexts';
import styles from './AiAssistant.module.scss';

type Props = {
  texts: AiAssistantTexts;
  // Sending is blocked account-wide, so the composer is gone — the pills have to
  // go inert with it, or they would fire a send that cannot land.
  disabled?: boolean;
  onSuggestionSelect: (suggestion: string) => void;
};

function ConversationEmptyState({
  texts,
  disabled,
  onSuggestionSelect,
}: Props) {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateIcon}>
        <MaterialIcon icon="auto_awesome" symbolsOutlined size="md-24" />
      </div>
      <Typography variant="h3">{texts.emptyTitle}</Typography>
      <Typography variant="body" className={styles.emptyStateSubtitle}>
        {texts.emptySubtitle}
      </Typography>
      <div className={styles.emptyStateSuggestions}>
        {texts.suggestions.map((suggestion, index) => (
          <button
            // static, non-reordered suggestion list; index disambiguates dupes
            // eslint-disable-next-line react/no-array-index-key
            key={`${suggestion}-${index}`}
            type="button"
            className={styles.suggestionPill}
            disabled={disabled}
            onClick={() => onSuggestionSelect(suggestion)}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ConversationEmptyState;
